<template>
  <div
    class="modal fade mt-5"
    id="establishmentModal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog" role="document">
        <div class="modal-content text-left">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form @submit.prevent.stop="submit">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t('establishment') }}</h4>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="p-4">
                <div v-if="monitor.visible" :class="monitor.type" class="alert">
                  {{ monitor.message }}
                </div>
                <validation-provider
                  name="establishment"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <treeselect
                    :maxHeight="200"
                    v-model="establishment"
                    valueFormat="object"
                    :options="options"
                    :auto-load-root-options="false"
                    :multiple="false"
                    :load-options="getOptions"
                  />
                  <span v-cloak class="text-danger small">{{ errors[0] }}</span>
                </validation-provider>
              </div>

              <div class="modal-footer d-flex flex-wrap">
                <button
                  class="btn btn-primary"
                  type="submit"
                  :disabled="invalid"
                >
                  {{ $t('buttons.save') }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect, { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'

export default {
  name: 'EstablishmentModal',
  components: {
    Treeselect,
  },
  data() {
    return {
      options: null,
      establishment: null,
      form: {},
      monitor: {
        visible: false,
        message: '',
        type: '',
      },
    }
  },
  mounted() {
    this.$bus.$on('trainee-establishment-modal.show', (data) => {
      this.form = data
      $('#establishmentModal').modal('show')
    })
    this.$bus.$on('trainee-establishment-modal.hide', () => {
      $('#establishmentModal').modal('hide')
    })
  },
  methods: {
    showMessage(message, type = 'info') {
      const types = {
        success: 'alert-success',
        error: 'alert-danger',
        info: 'alert-info',
      }
      this.monitor.message = message
      this.monitor.type = types[type] || types.info
      this.monitor.visible = true
    },
    hideMessage() {
      this.monitor.visible = false
    },
    async getOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.$store
          .dispatch('trainees/getEstablishmentsList', {
            company_id: this.form.companyId,
          })
          .then((resp) => {
            this.options = resp.map((item) =>
              Object.assign({}, { id: item.id, label: item.title })
            )
          })
      }
    },
    submit() {
      let data = { payload: {} }
      data.id = this.form.id || null
      data.payload.firstname = this.form.firstname || null
      data.payload.lastname = this.form.lastname || null
      data.payload.establishment_id = this.establishment.id || null
      data.payload.establishment_title = this.establishment.label || null

      if (data.payload.firstname && data.payload.lastname) {
        this.showMessage(this.$t('loading'))
        this.$store
          .dispatch('editTrainee', data)
          .then((response) => {
            this.$bus.$emit('trainee-establishment-modal.hide')
            this.$bus.$emit('trainee-establishment-update')
            this.hideMessage()
          })
          .catch((error) => {
            this.showMessage(this.$t('errors.serverError'), 'error')
            console.log(error)
            setTimeout(() => {
              this.hideMessage()
            }, 1500)
          })
      } else {
        this.showMessage(this.$t('errors.serverError'), 'error')
        setTimeout(() => {
          this.hideMessage()
        }, 1500)
      }
    },
  },
}
</script>
